import { render, staticRenderFns } from "./KeyMeasuresHome.vue?vue&type=template&id=513fad97&"
import script from "./KeyMeasuresHome.vue?vue&type=script&lang=js&"
export * from "./KeyMeasuresHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports